<template>
	<div class="full-width">
		<v-tabs
			dark
			v-model="activeTab"
			slider-color="yellow"
			:color="themeInputColor"
		>
			<v-tab
				v-for="(tab, i) in tabs"
				:key="i"
				:href="'#tab-' + i"
				:ripple="false"
				class="px-3"
			>
				{{ tab.name }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="activeTab">
			<v-tab-item value="tab-0">
				<dstr-gst-invoice-list
					:title="tabs[1].name"
					:themeInputColor="themeInputColor"
					appType="fantasy"
				/>
			</v-tab-item>
			<v-tab-item value="tab-1">
				<dstr-gst-invoice-list
					:title="tabs[1].name"
					:themeInputColor="themeInputColor"
					appType="rummy"
				/>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import dstrGstInvoiceList from "./dstr-gst-invoice-list.vue";
import { THEME_INPUT_COLOUR } from "../constants";

export default {
	components: {
		"dstr-gst-invoice-list": dstrGstInvoiceList
	},
	data() {
		return {
			themeInputColor: THEME_INPUT_COLOUR,
			activeTab: "tab-0",
			tabs: [
				{ name: "DSTR GST Invoice - Fantasy" },
				{ name: "DSTR GST Invoice - Rummy" }
			]
		};
	}
};
</script>

<style lang="scss"></style>
